import { Disclosure } from '@headlessui/react';
import UntitledIcon from '@payaca/untitled-icons';
import { FC, PropsWithChildren, ReactNode } from 'react';
import ConditionalWrapper from '../ConditionalWrapper/ConditionalWrapper';
import Tooltip from '../Tooltip/Tooltip';

export type AccordionProps = {
  title: string | ReactNode;
  titleTooltip?: string;
  chevronPosition?: 'left' | 'right';
  defaultOpen?: boolean;
  panelClassName?: string;
  disabled?: boolean;
  summary?: ReactNode;
};

const Accordion: FC<PropsWithChildren<AccordionProps>> = (props) => {
  const {
    title,
    titleTooltip,
    children,
    chevronPosition = 'right',
    defaultOpen,
    panelClassName,
    disabled = false,
    summary,
  } = props;

  return (
    <Disclosure defaultOpen={defaultOpen}>
      {({ open }) => {
        const titleNode =
          typeof title === 'string' ? (
            <span className="h4">{title}</span>
          ) : (
            title
          );

        const chevronNode = !disabled && (
          <UntitledIcon
            name={open ? 'chevron-up' : 'chevron-down'}
            className="h-5 w-5 shrink-0"
          />
        );

        const summaryNode = !open && summary;

        return (
          <>
            <ConditionalWrapper
              condition={!!titleTooltip}
              Wrapper={Tooltip}
              wrapperProps={{
                className: '!block',
                tooltipContent: titleTooltip,
              }}
            >
              <Disclosure.Button
                className="typography:prose bg-transparent p-0 w-full flex gap-2 cursor-pointer text-left items-center justify-between"
                disabled={disabled}
              >
                <span className="flex items-center gap-2">
                  {chevronPosition === 'left' && chevronNode}
                  {titleNode}
                  {chevronPosition === 'right' && summaryNode}
                </span>

                {chevronPosition === 'right' ? chevronNode : summaryNode}
              </Disclosure.Button>
            </ConditionalWrapper>

            {children && (
              <Disclosure.Panel className={panelClassName}>
                {children}
              </Disclosure.Panel>
            )}
          </>
        );
      }}
    </Disclosure>
  );
};

export default Accordion;
